(function(angular){
	'use strict';
	
	angular
		.module('beneficiaryAlertModule')
		.service('BeneficiaryAlertService', [
			'$http',
			'APP_BASE_PATH',
			BeneficiaryAlertServiceFunction
		]);
	
	function BeneficiaryAlertServiceFunction(
		$http,
		APP_BASE_PATH) {
		var service = this;

		service.getMissingBeneficiaries = function() {
			return $http.get(APP_BASE_PATH + '/account/entities-missing-beneficiaries.json');
		};
	}
})(window.angular);